import { call, put, takeEvery } from 'redux-saga/effects';
import * as type from '../ActionTypes';
import {
  getBankAccountDetailsOfUser,
  savebankAccountInfoForIndianUsersApi,
  updatebankAccountInfoForIndianUsersApi
} from '../../services/payment.service';

function* getUserPaymentInfo(action: any): any {
  try {
    const response = yield call(getBankAccountDetailsOfUser, action.payload);
    if (response?.statusCode === 200) {
      yield put({ type: type.GET_BANK_DETAILS_SUCCESS, data: response.data?.results?.[0] || {} });
    } else {
      yield put({ type: type.GET_BANK_DETAILS_FAILURE, error: response?.data });
    }
  } catch (e: any) {
    yield put({ type: type.GET_BANK_DETAILS_FAILURE, error: e.error });
  }
}

function* savebankAccountInfoForIndianUsers(action: any): any {
  try {
    const response = yield call(savebankAccountInfoForIndianUsersApi, action.payload);
    if (response?.statusCode === 201) {
      yield put({ type: type.SAVE_BANK_DETAILS_SUCESSS, data: response.data });
    } else {
      yield put({ type: type.SAVE_BANK_DETAILS_FAILURE, error: response?.data });
    }
  } catch (e: any) {
    yield put({ type: type.SAVE_BANK_DETAILS_FAILURE, error: e.error });
  }
}

function* updatebankAccountInfoForIndianUsers(action: any): any {
  try {
    const response = yield call(updatebankAccountInfoForIndianUsersApi, action.payload);
    if (response?.statusCode === 200) {
      yield put({ type: type.SAVE_BANK_DETAILS_SUCESSS, data: response.data });
    } else {
      yield put({ type: type.SAVE_BANK_DETAILS_FAILURE, error: response?.data });
    }
  } catch (e: any) {
    yield put({ type: type.SAVE_BANK_DETAILS_FAILURE, error: e.error });
  }
}

function* paymentSaga() {
  yield takeEvery(type.GET_BANK_DETAILS, getUserPaymentInfo);
  yield takeEvery(type.SAVE_BANK_DETAILS_REQUEST, savebankAccountInfoForIndianUsers);
  yield takeEvery(type.UPDATE_BANK_DETAILS_REQUEST, updatebankAccountInfoForIndianUsers);
}

export default paymentSaga;
